import React from 'react';
import PropTypes from 'prop-types';
import { getMerchantAdviceSectionData } from './configStructure'
import { format } from 'date-fns';
import parse from 'react-html-parser';

import './MerchantAdviceSection.scss'

const MerchantAdviceSection = (props) => {
    const merchantAdviceSectionData = getMerchantAdviceSectionData();
    return <div className="merchant-advice-section-card" >
           <span className="section-title">{props.sectionName}<span className="scope-divider"></span><span className="scope-view">{props.scope}</span></span>
        {props.fieldValues !== undefined && <div className="section-content">

            {merchantAdviceSectionData.dataColumns?.map((content, index) => {
                return <div className="list-view" key={index}>
                    <span className="list-title">{content.name}</span>
                    {Array.isArray(props.fieldValues) === true && props.fieldValues.map((fieldValue) => {
                        let value;
                        switch (content.displayType) {
                            case "DATE":
                                value = (props.isMerchantUser) ? format(fieldValue[content.columnKey], props.dateFormat) : format(fieldValue[content.columnKey], 'MMM dd, yyyy ');
                                break;
                            case "LETTER":
                                let displayTitle;
                                let isLetterTitleNull = fieldValue[content.columnKey] === null;
                                let letterTitle = isLetterTitleNull ? fieldValue.notifyMessage : fieldValue[content.columnKey];
                                if(!isLetterTitleNull){
                                letterTitle = letterTitle.substr(0, letterTitle.lastIndexOf(".")) + ".tiff";
                                const titleStart = letterTitle ? letterTitle.slice(0, 10) : '';
                                const titleFinish = letterTitle ? letterTitle.slice(-10) : '';
                                displayTitle = letterTitle && letterTitle.length < 25 ? letterTitle :`${titleStart}...${titleFinish}`;
                               
                                value = <a onClick={() => props.openModal(props.documents, fieldValue[content.columnKey], fieldValue["id"])}>{displayTitle}</a>;
                                } else{
                                    displayTitle = letterTitle;
                                    //value = <a onClick={() => props.openModal(props.documents, fieldValue[content.columnKey], fieldValue["id"])}>{displayTitle}</a>;
                                    value = <span key={fieldValue["id"]} className="list-value">{displayTitle === undefined ? "--" : displayTitle}</span>;
                                }
                                break;
                            default:
                                value = fieldValue[content.columnKey];
                                break;
                        }
                        return <span key={index} className="list-value">{value === undefined ? "--" : value}</span>
                    })}
                </div>
            })}
        </div>}

        {props.fieldValues !== undefined && (props.MsgToMerchant || props.followUp) && <span className="divider">{" "}</span>}

        {props.MsgToMerchant ? <div className="section-footer">
            <span className="section-footer-title">{merchantAdviceSectionData.messageData.name}</span>
            {props.MsgToMerchant === undefined ? <span className="section-footer-value">{"--"}</span> : <span className="section-footer-value" style={{whiteSpace: 'pre-wrap'}}>{parse(props.MsgToMerchant)}</span>}
            {props.MerchantPreferredMessage  && props.MerchantPreferredMessage!="null" &&
                <>
                    <span className="section-footer-divider">{" "}</span>
                    <span className="section-footer-title">{merchantAdviceSectionData.messageData.optionalName}</span>
                    <span className="section-footer-value" style={{whiteSpace: 'pre-wrap'}}>{parse(props.MerchantPreferredMessage)}</span>
                </>}
        </div>
            :
            props.eventCode === 'NOTIFY_AND_REQUEST_DOCS' && <div className="section-footer">
                <span className="section-footer-title">{merchantAdviceSectionData.messageData.substituteField}</span>
                {props.followUp === undefined ? <span className="section-footer-value">{"--"}</span> : <span className="section-footer-value">{props.followUp}</span>}
            </div>}
    </div>

}

MerchantAdviceSection.propTypes = {
    openModal: PropTypes.func,
    fieldValues: PropTypes.array,
    sectionName: PropTypes.string,
    documents: PropTypes.array,
    scope: PropTypes.string,
    MsgToMerchant: PropTypes.string,
    MerchantPreferredMessage: PropTypes.string,
    followUp: PropTypes.string
};

MerchantAdviceSection.defaultProps = {};

export default (MerchantAdviceSection);